'use client'
import Image from 'next/image'
import heroImg from '@/assets/hero-sturgeon.webp'
import { IconCheck, IconShield, IconLeaf, IconFish, IconWaves, IconCaviar, IconDownload } from '@/icons'
import { useCountUp } from '@/hooks/useCountUp'

export default function Hero() {
  const [tonsRef, tons] = useCountUp(180)
  const [prodRef, caviarV] = useCountUp(2115)
  const [meatRef, meatV] = useCountUp(9100)

  return (
    <section id="top" className="hero">
      <div className="hero-bg">
        <Image
          src={heroImg}
          alt="Осетровое хозяйство СК-АКВА"
          fill
          priority
          fetchPriority="high"
          sizes="100vw"
          className="hero-bg-img"
        />
      </div>
      <div className="hero-tint" />
      <div className="container hero-grid">
        <div>
          <h1>
            Современное<br />
            осетровое хозяйство<br />
            <span className="accent">полного цикла</span>
          </h1>
          <p className="hero-sub">
            Выращиваем осетровых пород рыб<br />
            и поставляем чёрную икру напрямую с ферм Дагестана и Астраханской области
          </p>

          <div className="hero-features">
            <div className="hf">
              <span className="hf-ic"><IconCheck width="18" height="18" /></span>
              <div>
                <div className="hf-t">Полный цикл</div>
                <div className="hf-d">от малька<br />до готовой продукции</div>
              </div>
            </div>
            <div className="hf">
              <span className="hf-ic"><IconShield width="18" height="18" /></span>
              <div>
                <div className="hf-t">Контроль качества</div>
                <div className="hf-d">на всех этапах<br />производства</div>
              </div>
            </div>
            <div className="hf">
              <span className="hf-ic"><IconLeaf width="18" height="18" /></span>
              <div>
                <div className="hf-t">Эко-технологии</div>
                <div className="hf-d">установки замкнутого<br />водоснабжения (УЗВ)</div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-image">
          <aside className="stats-card">
            <div className="stat-row" ref={tonsRef}>
              <span className="stat-ic"><IconWaves width="20" height="20" /></span>
              <div>
                <div className="stat-v">{tons}+ <span className="unit">тонн</span></div>
                <div className="stat-l">единовременное содержание<br />в УЗВ и садках</div>
              </div>
            </div>
            <div className="stat-row stat-row-production" ref={prodRef}>
              <span className="stat-ic"><IconCaviar width="20" height="20" /></span>
              <div className="stat-production">
                <div className="stat-production-title">Производство 2025 г.</div>
                <div className="stat-production-items">
                  <div>
                    <div className="stat-v">{caviarV} <span className="unit">кг</span></div>
                    <div className="stat-l">икра</div>
                  </div>
                  <div className="stat-production-divider" />
                  <div ref={meatRef}>
                    <div className="stat-v">{meatV} <span className="unit">кг</span></div>
                    <div className="stat-l">мясо осетра<br />и стерляди</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="stat-row">
              <span className="stat-ic"><IconFish width="20" height="20" /></span>
              <div>
                <div className="stat-v">2</div>
                <div className="stat-l">производственные<br />площадки</div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}
